<template>
  <div class="section section-blogs-3">
    <!-- Blogs 3 -->
    <div class="container">
      <div class="md-layout" style="margin-top:3em;">
        <div class="md-layout-item md-size-80 md-small-size-100 mx-auto">
          <h2>Writers' Dashboard</h2>
          <md-button class="md-success" @click="newBlogModal=true">New Post</md-button>
          <br />
          <blog-card
            card-plain
            type="horizontal"
            :shadow-normal="false"
            :no-colored-shadow="false"
            :card-image="cardBlogPost.cardBlogPost1"
          >
            <template slot="cardContent">
              <h6 class="card-category text-info">Enterprise</h6>
              <h3 class="card-title">
                <a href="javascript:void(0)">
                  Autodesk looks to future of 3D printing with Project
                  Escher
                </a>
              </h3>
              <p class="card-description">
                Like so many organizations these days, Autodesk is a company
                in transition. It was until recently a traditional boxed
                software company selling licenses. Today, it’s moving to a
                subscription model. Yet its own business model disruption is
                only part of the story — and…
                <a
                  href="javascript:void(0)"
                >Read More</a>
              </p>
              <p class="author">
                by
                <a href="javascript:void(0)">
                  <b>Mike Butcher</b>
                </a>, 2 days
                ago
              </p>
            </template>
          </blog-card>
          <blog-card
            card-plain
            type="horizontal"
            :shadow-normal="false"
            :no-colored-shadow="false"
            :card-image="cardBlogPost.cardBlogPost2"
          >
            <template slot="cardContent">
              <h6 class="card-category text-danger">
                <md-icon class="text-danger">trending_up</md-icon>Trending
              </h6>
              <h3 class="card-title">
                <a href="javascript:void(0)">6 insights into the French Fashion landscape</a>
              </h3>
              <p class="card-description">
                Like so many organizations these days, Autodesk is a company
                in transition. It was until recently a traditional boxed
                software company selling licenses. Today, it’s moving to a
                subscription model. Yet its own business model disruption is
                only part of the story — and…
                <a
                  href="javascript:void(0)"
                >Read More</a>
              </p>
              <p class="author">
                by
                <a href="javascript:void(0)">
                  <b>Mike Butcher</b>
                </a>, 2 days
                ago
              </p>
            </template>
          </blog-card>
          <blog-card
            card-plain
            type="horizontal"
            :shadow-normal="false"
            :no-colored-shadow="false"
            :card-image="cardBlogPost3.cardBlogPost1"
          >
            <template slot="cardContent">
              <h6 class="card-category text-success">Startups</h6>
              <h3 class="card-title">
                <a href="javascript:void(0)">Lyft launching cross-platform service this week</a>
              </h3>
              <p class="card-description">
                Like so many organizations these days, Autodesk is a company
                in transition. It was until recently a traditional boxed
                software company selling licenses. Today, it’s moving to a
                subscription model. Yet its own business model disruption is
                only part of the story — and…
                <a
                  href="javascript:void(0)"
                >Read More</a>
              </p>
              <p class="author">
                by
                <a href="javascript:void(0)">
                  <b>Megan Rose</b>
                </a>, 2 days
                ago
              </p>
            </template>
          </blog-card>
        </div>
      </div>
    </div>
    <!-- End Blogs 3 -->
    <div class="modal modal-bg" :class="{ show: newBlogModal }">
      <modal
        v-if="newBlogModal"
        modal-with-card
        header-card-color="green"
        type="modal-login"
        card-classes="md-card-login"
        @close="newBlogModal = false"
      >
        <template slot="header">
          <md-card-header class="md-card-header-green">
            <md-button
              class="md-simple md-white md-close md-just-icon md-round modal-default-button"
              @click="newBlogModal = false"
            >
              <md-icon>clear</md-icon>
            </md-button>
            <h4 class="card-title">New Blog</h4>
          </md-card-header>
        </template>

        <template slot="body">
          <div>
            <div class="md-list" slot="input">
              <li class="md-list-item">
                <a
                  href="javascript:void(0)"
                  class="md-list-item-router md-list-item-container md-button-clean dropdown"
                >
                  <div class="md-list-item-content">
                    <drop-down direction="down">
                      <md-button
                        slot="title"
                        class="md-button md-button-link md-simple dropdown-toggle"
                        data-toggle="dropdown"
                      >
                        <i class="material-icons">apps</i>
                        <p>{{selectedType}}</p>
                      </md-button>
                      <ul class="dropdown-menu dropdown-with-icons">
                        <li
                          v-for="(type, index) in blogTypes"
                          :key="index"
                          @click="selectedType = type"
                        >
                          <p class="description">{{type}}</p>
                        </li>
                      </ul>
                    </drop-down>
                  </div>
                </a>
              </li>
            </div>
            <div slot="input">
              <md-field class="has-danger">
                <label>Post Title</label>
                <md-input v-model="blogTitle"></md-input>
              </md-field>
            </div>
          </div>
        </template>

        <template slot="footer">
          <md-button href="javascript:void(0)" class="md-simple md-success md-lg" @click="newBlog">Create Post</md-button>
        </template>
      </modal>
    </div>
  </div>
</template>

<script>
import { BlogCard, Modal } from "@/components";
import firebase from 'firebase'
export default {
  name: "Blogs",
  components: {
    BlogCard,
    Modal
  },
  data() {
    return {
      cardBlogPost: {
        cardBlogPost1: require("@/assets/img/examples/card-blog4.jpg"),
        cardBlogPost2: require("@/assets/img/office2.jpg")
      },
      cardBlogPost2: {
        cardBlogPost1: require("@/assets/img/examples/blog5.jpg"),
        cardBlogPost2: require("@/assets/img/examples/blog7.jpg")
      },
      cardBlogPost3: {
        cardBlogPost1: require("@/assets/img/examples/blog8.jpg")
      },
      cardBlogPost4: {
        cardBlogPost1: require("@/assets/img/bg5.jpg"),
        cardBlogPost2: require("@/assets/img/examples/blog6.jpg")
      },
      newBlogModal: false,
      blogTypes: ["PR", "Artysan"],
      selectedType: "PR",
      blogTitle: null,
      author: 'Temp author'
    };
  },
  methods: {
    newBlog() {
      // TODO Make store and get author
      const currentTimestamp = firebase.firestore.Timestamp.now()
      firebase.firestore().collection('blog').add({
        title: this.blogTitle,
        type: this.selectedType,
        author: this.author,
        created: currentTimestamp,
        updated: currentTimestamp
      })
      .then(doc => {
        const blogId = doc.id
        this.$router.push({name: 'writer', params: {id: blogId}})
      })
      .catch(e => {
        console.log(e);
      })
    }
  }
};
</script>